import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { useAuth } from "./contexts/AuthContext";
import { Layout } from "./components/Layout";
import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Dashboard } from "./pages/Dashboard";
import { Contracts } from "./pages/Contracts";
import { ContractSummary } from "./pages/ContractSummary";
import { Calendar } from "./pages/Calendar";
import { Pending } from "./pages/Pending";
import { ContractProvider } from "./contexts/ContractContext";
import { CalendarProvider } from "./contexts/CalendarContext";
import { Loader2 } from "lucide-react";

export function App() {
  const { isLoading, user } = useAuth(); // Access the loading state and user from AuthContext

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-gradient-to-br from-background to-secondary">
        <div className="text-center space-y-4">
          <div className="flex items-center justify-center">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
          </div>
          <p className="text-lg font-medium text-muted-foreground">Loading...</p>
        </div>
      </div>
    );                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
  }

  if (!user) {
    // If the user is not authenticated, only render public routes
    return (
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="*" element={<Login />} /> {/* Redirect all unknown routes to login */}
        </Routes>
      </Router>
    );
  }

  // Check if user is a manager
  const isManager = user.role === 'manager';

  return (
    <ContractProvider>
      <CalendarProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <Routes>
            {/* Protected routes */}
            <Route element={<ProtectedRoute />}>
              <Route element={<Layout />}>
                {/* Redirect managers to contracts with modal open, others to dashboard */}
                <Route path="/" element={isManager ? <Navigate to="/contracts?openModal=true" replace /> : <Dashboard />} />
                <Route path="/contracts" element={<Contracts />} />
                <Route path="/contracts/:id" element={<ContractSummary />} />
                <Route path="/calendar" element={<Calendar />} />
                {/* Only render Pending route for non-manager roles */}
                {!isManager ? (
                  <Route path="/pending" element={<Pending />} />
                ) : (
                  <Route path="/pending" element={<Navigate to="/" replace />} />
                )}
                {/* Catch-all redirect to dashboard */}
                <Route path="*" element={<Dashboard />} />
              </Route>
            </Route>
          </Routes>
        </Router>
        <Toaster />
      </CalendarProvider>
    </ContractProvider>
  );
}